module.exports = __webpack_public_path__ + "img/D@2x.28bddc6f.jpg";